import { Box, Chip } from "@mui/material";

import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PropTypes from "prop-types";

/**
 * Status badge component for blog-post statuses
 * Uses semantic color tokens from the theme
 *
 * @param {Object} props
 * @param {string} props.status - The status value (e.g., 'draft', 'review', 'released', 'published')
 * @param {string} props.label - The display label for the status
 * @param {string} props.size - Size of the chip ('small' | 'medium')
 * @param {function} [props.onClick] - Optional click handler for the badge
 * @param {boolean} [props.open] - Whether the badge is in an "open" state (for dropdown indicators)
 * @param {boolean} [props.disabled] - Whether the badge is disabled
 * @returns {JSX.Element}
 */
export default function BlogPostStatusBadge({
  status,
  label,
  size = "small",
  onClick,
  open = false,
  disabled = false,
  ariaLabelledby,
}) {
  // Map backend status values to chip variant names
  const statusMap = {
    draft: {
      color: "default",
      label: "Entwurf",
    },
    review: {
      color: "warning",
      label: "In Prüfung",
    },
    released: {
      color: "success",
      label: "Freigegeben",
    },
    published: {
      color: "info",
      label: "Veröffentlicht",
    },
    archived: {
      color: "error",
      label: "Archived",
    },
  };

  const stateObj = statusMap[status] || {
    color: "default",
    label: "Status",
  };

  const color = stateObj.color || "default";
  label = label ? label : stateObj.label || "";

  // Custom styling for tiny size
  const tinySx =
    size === "tiny"
      ? {
          fontSize: "0.7rem",
          height: 20,
        }
      : {};

  return (
    <Chip
      label={
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          <span aria-labelledby={ariaLabelledby}>{label}</span>
          {onClick &&
            !disabled &&
            (open ? (
              <ExpandLessIcon fontSize="small" />
            ) : (
              <ExpandMoreIcon fontSize="small" />
            ))}
        </Box>
      }
      color={color}
      size={size === "tiny" ? "small" : size}
      sx={tinySx}
      onClick={!disabled ? onClick : undefined}
      disabled={disabled}
    />
  );
}

BlogPostStatusBadge.propTypes = {
  // status: PropTypes.string.isRequired,
  // label: PropTypes.string.isRequired,
  size: PropTypes.oneOf(["tiny", "small", "medium"]),
  onClick: PropTypes.func,
  open: PropTypes.bool,
  disabled: PropTypes.bool,
};
